import {formatarDateTime} from './formatarDateTime'
import cdCurrency from './cdCurrency'

export default {
    install(Vue) {
        Vue.filter('DateTimeFormater', formatarDateTime)
        Vue.filter('cdCurrency', cdCurrency)
    }
}